/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { useFormContext, useWatch } from 'react-hook-form';
import QuestionFieldArray from '../../../../../components/HookFormComponents/components/EpQuestionFieldArray';
import { notificationService } from '../../../../../services/notificationService';
import { useEffect } from 'react';

const QuestionsAnswers = () => {
  const { setValue, getValues } = useFormContext();

  const NotificationTechnicalComplaintId = useWatch({
    name: 'notificationTechnicalComplaintId.inputValue',
  });

  const { getNotificationQualityDeviationsQuestionsAnswers } =
    notificationService;

  const { data: notificationCategoriesQuestionsAnswers }: { data: any } =
    getNotificationQualityDeviationsQuestionsAnswers(
      NotificationTechnicalComplaintId,
    );

  // const questions = getValues('questions');
  const questions = useWatch({ name: 'questions' });

  interface verifyQuestionsByQuestionIdProps {
    arr1: any;
    arr2: any;
  }

  const verifyQuestionsByQuestionId = ({
    arr1,
    arr2,
  }: verifyQuestionsByQuestionIdProps) => {
    if (arr1 && arr1.length > 0 && arr2 && arr2.length > 0)
      return arr1.length === arr2.length &&
        arr1.every((item: any, index: number) => item.questionId === arr2[index].questionId);
    return false;
  };


  useEffect(() => {
    console.log(
      `NotificationTechnicalComplaintId:`,
      NotificationTechnicalComplaintId,
    );
    console.log(
      `notificationCategoriesQuestionsAnswers:`,
      notificationCategoriesQuestionsAnswers,
    );

    const haveQuestionsToShow =
      NotificationTechnicalComplaintId &&
      notificationCategoriesQuestionsAnswers &&
      notificationCategoriesQuestionsAnswers.length > 0;

    const haveChangedQuestions = verifyQuestionsByQuestionId({
      arr1: questions,
      arr2: notificationCategoriesQuestionsAnswers,
    });

    console.log(` haveQuestionsToShow:`, haveQuestionsToShow);
    console.log(` haveChangedQuestions:`, haveChangedQuestions);

    if (
      !NotificationTechnicalComplaintId ||
      !notificationCategoriesQuestionsAnswers ||
      notificationCategoriesQuestionsAnswers.length === 0
    ) {
      setValue('questions', []);
    }

    if (
      NotificationTechnicalComplaintId &&
      !notificationCategoriesQuestionsAnswers
    ) {
      setValue('questions', []);
    }

    if (
      haveQuestionsToShow &&
      (questions.length === 0 || !haveChangedQuestions)
    ) {
      console.log('mudou questions');
      setValue('questions', notificationCategoriesQuestionsAnswers);
    }
  }, [notificationCategoriesQuestionsAnswers]);

  useEffect(() => {
    console.log(`questions:`, questions);
  }, [questions]);

  if (!NotificationTechnicalComplaintId) {
    return null;
  }



  if (questions.length > 0) {
    return <QuestionFieldArray />;
  }
};

export default QuestionsAnswers;
